import { Center }                               from '@chakra-ui/react';
import EntertainmentCards                       from '@/pages/Home/components/EntertainmentCards';
import FondationsEntertainmentModel             from '@/models/services/fondations/EntertainmentModel';
import PageContainer                            from '@/components/pageContainer/PageContainer';
import PageTitle                                from '@/components/pageTitle/PageTitle';
import { Spinner }                              from '@chakra-ui/react';
import { Grid }                                 from '@chakra-ui/react';
import { Stack }                                from '@chakra-ui/react';
import UserCard                                 from '@/pages/Home/components/UserCard';
import authStore                                from '@/stores/authStore';
import dayjs                                    from 'dayjs';
import useApiCollection                         from '@widesk-core/hooks/useApiCollection';
import useFetch                                 from '@widesk-core/hooks/useFetch';
import { useTranslation }                       from 'react-i18next';
import React                                    from 'react';
import { ModalData }                            from '@/components/modal/Modal';
import RelationRequestsContainer                from './components/RelationRequestsContainer';
import Modal                                    from '@/components/modal/Modal';
import TransfersContainer                       from './components/TransfersContainer';
import useScreenSize                            from '@/hooks/useScreenSize';

export default function HomePage() {

	const { t } = useTranslation();
	const { isLG } = useScreenSize();

	const currentUser = authStore.currentUser;

	const [modalData, setModalData] = React.useState<ModalData | undefined>();
	const [modalIsOpen, setModalIsOpen] = React.useState(false);

	const collectionEntertainment = useApiCollection(FondationsEntertainmentModel);

	const { data: entertainments, isLoading } = useFetch(async () => {
		const now = dayjs().format('YYYY/MM/DD');
		await collectionEntertainment.setSort('dateStart', 'asc').setFilter('dateEnd[after]', now).list();
		return collectionEntertainment.models;
	}, true);

	if (isLoading) {
		return (
			<Center height="100%">
				<Spinner borderWidth="4px" size="xl" />
			</Center>
		);
	}

	return (
		<PageContainer>
			<Modal
				model={modalData?.model}
				isDangerous={modalData?.isDangerous}
				isOpen={modalIsOpen}
				setIsOpen={setModalIsOpen}
				titleComponent={modalData?.titleComponent}
				bodyComponent={modalData?.bodyComponent}
				onConfirm={modalData?.onConfirm}
				onClose={modalData?.onClose}
				onSuccess={modalData?.onSuccess}
			/>
			<Stack gap="20px" maxWidth="1000px">
				<PageTitle>{t('pages.home.greetings', { name: currentUser.firstName })}</PageTitle>
				<UserCard />
				<EntertainmentCards entertainments={entertainments || []} />
				<Grid
					gridTemplateColumns={isLG ? '0.5fr 0.5fr' : '1fr'}
					gap="20px"
				>
					<RelationRequestsContainer 
						setModalData={setModalData}
						setModalIsOpen={setModalIsOpen}
					/>
					<TransfersContainer 
						setModalData={setModalData}
						setModalIsOpen={setModalIsOpen}
					/>
				</Grid>
			</Stack>
		</PageContainer>
	);
}
